import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    departments: [
      { dep: 'EK', title: 'Beschaffung', color: '#fd7e14' },
      { dep: 'FE', title: 'Entwicklung', color: '#6f42c1' },
      { dep: 'PRO', title: 'Produktion', color: '#28a745' },
      { dep: 'QM', title: 'Qualitätsmanagement', color: '#ff0099' },
      { dep: 'VT', title: 'Vertrieb und Marketing', color: '#17a2b8' },
      { dep: 'WE', title: 'Warenannahme', color: '#dc3545' },
      { dep: 'BO', title: 'Betriebsordnungen', color: '#0088ff' },
    ],
    docList: [],
  },
  getters: {
    departments: (state) => state.departments,
    department: (state) => (dep) =>
      state.departments.find((item) => item.dep == dep),
    docList: (state) => state.docList,
  },
  mutations: {
    setDocList: (state, docs) => (state.docList = docs),
  },
  actions: {
    async loadDocList({ commit, getters }) {
      if (getters.docList.length == 0)
        await Vue.prototype.$axios.get('qmd/cache').then((res) => {
          commit('setDocList', res.data)
        })
    },
  },
  modules: {},
}
